import * as Constants from '../constants';
import { default as Endpoint } from '../../api/Endpoint';

export function requestFallbackAssetsByClass() {
  return {
    type: Constants.REQUEST_FALLBACK_ASSETS
  };
}
export function receiveFallbackAssetsByClass(json, error) {
  return {
    type: Constants.RECEIVE_FALLBACK_ASSETS,
    data: json,
    error
  };
}

export function requestSaveFallbackAsset(assetType, clearFallback) {
  return () => ({
    type: Constants.REQUEST_SAVE_FALLBACK_ASSET,
    assetType,
    clearFallback
  });
}
export function receiveSaveFallbackAsset(assetType, clearFallback) {
  return (json, error) => ({
    type: Constants.RECEIVE_SAVE_FALLBACK_ASSET,
    data: json,
    assetType,
    error,
    clearFallback
  });
}

export function clearFallbackAssets(type, options = {}) {
  const path = `ecs/api/class/${type}/fallback`;
  return new Endpoint(
    path,
    requestSaveFallbackAsset(type, true),
    receiveSaveFallbackAsset(type, true)
  )
    .withMethod('DELETE')
    .withOptions(options)
    .call();
}

export function setFallbackAsset(type, asset, options = {}) {
  const path = `ecs/api/asset/${asset.uuid}`;
  const body = JSON.stringify({ fallback: 'Y' });
  return new Endpoint(
    path,
    requestSaveFallbackAsset(type),
    receiveSaveFallbackAsset(type)
  )
    .withMethod('POST')
    .withBody(body)
    .withOptions(options)
    .call();
}
